import Quill from 'quill'
import EventBus from '@/assets/js/eventBus.js'

let Link = Quill.import('formats/link');
class LinkBlot extends Link {
  static create(link) {
    let node = super.create();
    // console.log("Creating a link", link)
    node.setAttribute('href', link.href);
    node.setAttribute('target', link.target);
    node.addEventListener('click', event => {
			EventBus.$emit('linkClicked', { node, link, event })
		})
    return node;
  }
  static formats(node) {
    return {
      href:  node.getAttribute('href'),
      target:  node.getAttribute('target')
    }
  
  }
  static value(node) {
    return {
      href:  node.getAttribute('href'),
      target:  node.getAttribute('target')
     }
  }
}
LinkBlot.blotName = 'link';
LinkBlot.tagName = 'a';
LinkBlot.className = 'link-blot-class'

export default LinkBlot